import { DoubleRow } from '../../../web/src/components/display/double-row.jsx';

/**
 * Returns a `renderActions` callback for DataTable that shows the familiar
 * edit/delete menu but keeps the mockups inert (no navigation, no mutation).
 * @param {(key: string, vars?: Record<string, unknown>) => string} t
 * @returns {(row: Record<string, unknown>) => Array<{ label: string, onClick: () => void, danger?: boolean }>}
 */
export function inertActions(t) {
	return () => [
		{ label: t('btn.edit'), onClick: () => {} },
		{ label: t('btn.delete'), onClick: () => {}, danger: true },
	];
}

/**
 * Renders a transfer/schedule pair row via the app's real DoubleRow
 * component (the `╰→` two-sided subline). Returns null for non-pair rows so
 * DataTable falls back to its default single-row rendering.
 * @param {Record<string, unknown>} row
 * @param {Array<Record<string, unknown>>} columns
 * @param {number} maxPriority
 * @param {Array<Record<string, unknown>>} actions
 * @param {{ rowLink?: (row: Record<string, unknown>) => string | undefined, navigate?: (path: string) => void, dateFormat?: string }} [nav]
 * @returns {import('react').ReactElement | null}
 */
export function pairRow(row, columns, maxPriority, actions, nav) {
	return DoubleRow(row, columns, maxPriority, actions, nav);
}
